/**
 * @friskai/frisk-js Environment Variables
 *
 * Environment variable names and defaults for Frisk SDK configuration.
 */

// Environment variable names
/** API key env var name. */
export const FRISK_API_KEY = "FRISK_API_KEY";
/** API base URL env var name. */
export const FRISK_BASE_URL = "FRISK_BASE_URL";
/** OTLP telemetry endpoint env var name. */
export const FRISK_TELEMETRY_ENDPOINT = "FRISK_TELEMETRY_ENDPOINT";
/** Shutdown timeout env var name (milliseconds). */
export const FRISK_SHUTDOWN_TIMEOUT_MS = "FRISK_SHUTDOWN_TIMEOUT_MS";
/** OTEL service name env var name. */
export const FRISK_SERVICE_NAME = "FRISK_SERVICE_NAME";
/** OTEL service namespace env var name. */
export const FRISK_SERVICE_NAMESPACE = "FRISK_SERVICE_NAMESPACE";
/** Debug logging toggle env var name. */
export const FRISK_DEBUG = "FRISK_DEBUG";

// Default values
/** Default Frisk API base URL. */
export const FRISK_BASE_URL_DEFAULT = "https://api.frisk.ai";
/** Default OTLP telemetry endpoint. */
export const FRISK_TELEMETRY_ENDPOINT_DEFAULT = "https://otel-collector.docker.localhost:443";
/** Default shutdown timeout in milliseconds. */
export const FRISK_SHUTDOWN_TIMEOUT_MS_DEFAULT = 5000;
/** Default OTEL service name. */
export const FRISK_SERVICE_NAME_DEFAULT = "frisk-js-sdk";
/** Default OTEL service namespace. */
export const FRISK_SERVICE_NAMESPACE_DEFAULT = "friskai";

/**
 * Get an environment variable value with optional default
 */
export function getEnv(
	name: string,
	defaultValue?: string,
): string | undefined {
	return process.env[name] ?? defaultValue;
}

/**
 * Get a required environment variable, throwing if not set
 */
export function requireEnv(name: string): string {
	const value = process.env[name];
	if (!value) {
		throw new Error(`Required environment variable ${name} is not set`);
	}
	return value;
}
